export const recyclerLocationData = [
    {id: 1, recyclerId: 1, name: "Pittsburgh, PA"},
    {id: 2, recyclerId: 1, name: "New Orleans, LA"},
    {id: 3, recyclerId: 1, name: "Toledo, OH"},
    {id: 4, recyclerId: 1, name: "St. Louis, MO"},
    {id: 5, recyclerId: 1, name: "Riverside, CA"},
    {id: 6, recyclerId: 1, name: "Orlando, FL"},
    {id: 7, recyclerId: 1, name: "Fresno, CA"},
    {id: 8, recyclerId: 1, name: "Wichita, KS"},
    {id: 9, recyclerId: 1, name: "Tucson, AZ"},
    {id: 10, recyclerId: 1, name: "Omaha, NE"},
    {id: 11, recyclerId: 2, name: "El Paso, TX"},
    {id: 12, recyclerId: 2, name: "Hialeah, FL"},
    {id: 13, recyclerId: 2, name: "Aurora, CO"},
    {id: 14, recyclerId: 2, name: "Portland, OR"},
    {id: 15, recyclerId: 2, name: "Anchorage, AK"},
    {id: 16, recyclerId: 2, name: "Greensboro, NC"},
    {id: 17, recyclerId: 2, name: "Lincoln, NE"},
    {id: 18, recyclerId: 2, name: "Tulsa, OK"},
    {id: 19, recyclerId: 2, name: "Laredo, TX"},
    {id: 20, recyclerId: 2, name: "Garland, TX"},
    {id: 21, recyclerId: 3, name: "Santa Ana, CA"},
    {id: 22, recyclerId: 3, name: "Raleigh, NC"},
    {id: 23, recyclerId: 3, name: "Durham, NC"},
    {id: 24, recyclerId: 3, name: "Jersey City, NJ"},
    {id: 25, recyclerId: 3, name: "Omaha, NE"},
    {id: 26, recyclerId: 3, name: "Henderson, NV"},
    {id: 27, recyclerId: 3, name: "Saint Paul, MN"},
    {id: 28, recyclerId: 3, name: "Portland, OR"},
    {id: 29, recyclerId: 3, name: "Chula Vista, CA"},
    {id: 30, recyclerId: 3, name: "Stockton, CA"},
    {id: 31, recyclerId: 4, name: "Stockton, CA"},
    {id: 32, recyclerId: 4, name: "Tulsa, OK"},
    {id: 33, recyclerId: 4, name: "Cleveland, OH"},
    {id: 34, recyclerId: 4, name: "Winston–Salem, NC"},
    {id: 35, recyclerId: 4, name: "New Orleans, LA"},
    {id: 36, recyclerId: 4, name: "Santa Ana, CA"},
    {id: 37, recyclerId: 4, name: "Pittsburgh, PA"},
    {id: 38, recyclerId: 4, name: "Sacramento, CA"},
    {id: 39, recyclerId: 4, name: "Irvine, CA"},
    {id: 40, recyclerId: 4, name: "Raleigh, NC"},
    {id: 41, recyclerId: 5, name: "Madison, WI"},
    {id: 42, recyclerId: 5, name: "Sacramento, CA"},
    {id: 43, recyclerId: 5, name: "Nashville, TN"},
    {id: 44, recyclerId: 5, name: "Glendale, AZ"},
    {id: 45, recyclerId: 5, name: "Chula Vista, CA"},
    {id: 46, recyclerId: 5, name: "Honolulu, HI"},
    {id: 47, recyclerId: 5, name: "Laredo, TX"},
    {id: 48, recyclerId: 5, name: "Fresno, CA"},
    {id: 49, recyclerId: 5, name: "Pittsburgh, PA"},
    {id: 50, recyclerId: 5, name: "Garland, TX"},
    {id: 51, recyclerId: 6, name: "Orlando, FL"},
    {id: 52, recyclerId: 6, name: "Tampa, FL"},
    {id: 53, recyclerId: 6, name: "Laredo, TX"},
    {id: 54, recyclerId: 6, name: "Newark, NJ"},
    {id: 55, recyclerId: 6, name: "Glendale, AZ"},
    {id: 56, recyclerId: 6, name: "Durham, NC"},
    {id: 57, recyclerId: 6, name: "Saint Paul, MN"},
    {id: 58, recyclerId: 6, name: "Bakersfield, CA"},
    {id: 59, recyclerId: 6, name: "Sacramento, CA"},
    {id: 60, recyclerId: 6, name: "Lincoln, NE"}
];
